import { Box, Grid } from "@mui/material";
import VerifyEmailStep, { VerifyEmailProps } from "../../components/Onboarding/VerifyEmailStep/VerifyEmailStep";
import colors from "../../colors";

export type SignUpProps = VerifyEmailProps;


const ChangeEmail = (props: SignUpProps) => (
  <Box
    sx={{
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      width: "100%",
      height: "100%"
    }}>
    <Box
      sx={{
        overflow: 'auto',
        backgroundColor: colors.greyBackdrop,
        height: '100%',
        width: '100%'
      }}>
      <Box
        sx={{
          paddingLeft: 4,
          paddingRight: 4,
          paddingTop: 10,
          width: "100%",
          paddingBottom: 4
        }}>
        <Grid container>
          <Grid size={{ xs: 12, md: 1 }} sx={{
            width: { xs: '100%' }
          }} />
          <Grid size={{ xs: 12, md: 10 }}>
            <VerifyEmailStep
              {...props}
            />
          </Grid>
          <Grid size={{ xs: 12, md: 1 }} sx={{
            width: { xs: '100%' }
          }} />
        </Grid>
      </Box>
    </Box>
  </Box>
);

export default ChangeEmail;
